// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__ujvjD","title":"style_title__1VtwN","cover_image":"style_cover_image__24-o7","bread_crumb_box":"style_bread_crumb_box__2CPSC"};